import { FC, useEffect } from 'react';
import { Main } from './main';
import { $Locale } from '@lemon8/web-app-shared/atom';
import { useAtomValue } from 'jotai';
import { useTranslation } from 'react-i18next';
import { MainV2 } from './main-v2';
import { SharePanel } from '~/components/share/share-panel';

const PageShowEventEmitter = () => {
  const { language } = useAtomValue($Locale);

  useEffect(() => {
    // change tea language header
    window.Tea('config', {
      language,
      evtParams: {
        current_page_name: 'website_homepage',
        language,
      },
    });
    window.Tea('wap_pageshow');
  }, [language]);

  return null;
};

const ChangeLanguage = () => {
  const { language } = useAtomValue($Locale);
  const { i18n } = useTranslation();

  useEffect(() => {
    // change ui-language
    i18n.changeLanguage(language).catch(() => void 0);
  }, [i18n, language]);

  return null;
};

export const HomepageBody: FC = () => {
  return (
    <>
      <PageShowEventEmitter />
      <ChangeLanguage />
      <MainV2 />
      <SharePanel />
    </>
  );
};
